/**
 * 国际化配置项
 * Created at 2021-09-30 16:31
 * @author teapot
 */
import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import zhCN from "./zh-cn.json";
import zhHK from "./zh-HK.json";

const resources = {
  "zh-CN": {
    translation: zhCN,
  },
  "zh-HK": {
    translation: zhHK,
  },
};

const defaultLanguage = localStorage.getItem("i18nextLng") || "zh-HK";

i18next.use(initReactI18next).init({
  fallbackLng: "zh-HK",
  lng: defaultLanguage ? defaultLanguage  : "zh-HK",
  resources,
  detection: {
    caches: ["localStorage"],
  },
});

const setLocal = (local: "zh-CN" | "zh-HK") => {
  localStorage.setItem("i18nextLng", local);
  i18next.changeLanguage(local);
};

const locals = () => {
  return i18next.language;
};

export { setLocal, locals };
